import { render, staticRenderFns } from "./BaseModel.vue?vue&type=template&id=fa640e7e"
import script from "./BaseModel.vue?vue&type=script&lang=js"
export * from "./BaseModel.vue?vue&type=script&lang=js"
import style0 from "./BaseModel.vue?vue&type=style&index=0&id=fa640e7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports